'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { buildSendFromResponders } from 'conversations-internal-schema/widget-data/operators/buildSendFromResponders';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
import { filterSystemUserResponders } from '../operators/filterSystemUserResponders';
export const getSendFromResponders = createSelector([getLatestWidgetData], widgetData => filterSystemUserResponders(buildSendFromResponders(widgetData)));